<template>
  <card>
    <list
      :withMap="true"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :filters="filters"
      :searchDisable="true"
      :exportsData="exportsData"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      filters: [
        {
          key: "dealer",
          title: "Бизнес",
          titleKey: "llc_name",
        },
        {
          key: "user",
          title: "Торговый представитель",
          titleKey: "name",
          params: { role_code: "tp_admin" },
        },
      ],
      val: [],
      modalCreate: "product",
      fields: [
        {
          col:' col-12 col-md-12',
          key: "cost_type",
          label: "Цены",
          type: "selectlist",
          values: [
            {
              title: "Стандартные",
              value: "COST_TYPE_PRICE"
            },
            {
              title: "Дилерские",
              value: "COST_TYPE_DEALER_PRICE"
            },
            {
              title: "Супер дилерские",
              value: "COST_TYPE_SUPER_DEALER_PRICE"
            },
            {
              title: "Оптовые",
              value: "COST_TYPE_WHOLESALE_PRICE"
            },
          ]
        },
        {
          col: " col-12 col-md-12",
          key: "name",
          label: "Название",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "dealer",
          label: "Владелец ",
          type: "select",
          modal: "dealer",
          selectKey: "full_name",
        },
        {
          col: " col-12 col-md-12",
          key: "new_images",
          resultKey: "media",
          label: "Фотографии торговой точки",
          type: "imgs",
          image_key: "path_small",
          link: "media",
        },
        {
          col:' col-12 col-md-12',
          key: "visiting_days",
          label: "Дни",
          type: "daystable",
        },
        {
          col: " col-12 col-md-12",
          key: "location_id",
          label: "Адрес",
          type: "location",
        },
        {
          col: " col-12 col-md-12",
          key: "address",
          label: "Адрес",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          col: " col-12 col-md-12",
          key: "description",
          label: "Ориентир",
          type: "textarea",
          isMultiLang: true,
        },
        {
          col: " col-12 col-md-6",
          key: "lat",
          label: "Широта",
          type: "field",
          textType: "number",
        },
        {
          col: " col-12 col-md-6",
          key: "lon",
          label: "Долгота",
          type: "field",
          textType: "number",
        },
      ],
      exportsData: [
        {
          type: "export-coords",
          url: '/shops/export-excel', 
          name: 'Клиентская_база_с_координатами'
        },
        {
          type: "export-all",
          url: '/shops/export-all',
          url_import: '/shops/import-all',
          name: 'Клиентская_база'
        }
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_shop",
      itemLink: "shops",
      setLink: "shops",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy: "id",
        },
        {
          key: "name",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "address",
          title: "Адрес",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "dealer",
          object: "phone",
          control: false,
          disableLink: true,
          align: "left",
          title: "Номер владельца",
        },
        {
          key: "dealer",
          object: "llc_name",
          title: "Оргранизация",
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
